import { styled } from '@mui/material/styles';
import { RouterLinkButton } from '@aibees/shared/router';

export const Wrapper = styled(RouterLinkButton)`
  gap: ${(p) => p.theme.spacing(1)};
  border-width: 2px !important;
`;
